import { createFeature, createReducer, on } from '@ngrx/store';
import { LombardConfirmationData } from '../entities/lombard-confirmation.entity';
import { Lombard } from '../entities/lombard.entity';
import { lombardActions, lombardApiActions } from './lombard.actions';

export interface LombardState {
  loading: boolean;
  applying: boolean;
  lombard: Lombard;
  faqs: string[];
  error: string;
  confirmationData: LombardConfirmationData;
  hasDismissedTeaserRecently: boolean;
  hasDismissedOffer: boolean;
  hasAppliedCredit: boolean;
}

const initialState: LombardState = {
  loading: false,
  applying: false,
  lombard: null,
  faqs: [],
  error: null,
  confirmationData: null,
  hasDismissedTeaserRecently: false,
  hasDismissedOffer: false,
  hasAppliedCredit: false,
};

export const lombardFeature = createFeature({
  name: 'lombard',
  reducer: createReducer(
    initialState,
    on(
      lombardActions.loadLombard,
      (state): LombardState => ({
        ...state,
        loading: true,
        hasDismissedOffer: false,
        hasAppliedCredit: false,
      }),
    ),
    on(
      lombardActions.loadFAQs,
      (state): LombardState => ({
        ...state,
        loading: true,
      }),
    ),
    on(
      lombardApiActions.loadLombardSuccess,
      (state, { lombard }): LombardState => ({
        ...state,
        lombard,
        loading: false,
        error: null,
      }),
    ),
    on(
      lombardApiActions.loadLombardFailure,
      (state, { error }): LombardState => ({
        ...state,
        error,
        loading: false,
      }),
    ),
    on(
      lombardApiActions.loadFAQsSuccess,
      (state, { faqs }): LombardState => ({
        ...state,
        faqs,
        loading: false,
        error: null,
      }),
    ),
    on(
      lombardApiActions.loadFAQsFailure,
      (state, { error }): LombardState => ({
        ...state,
        error,
        loading: false,
      }),
    ),
    on(
      lombardActions.applyForCredit,
      (state): LombardState => ({
        ...state,
        applying: true,
      }),
    ),
    on(
      lombardApiActions.applyForCreditSuccess,
      (state, { lombard }): LombardState => ({
        ...state,
        applying: false,
        hasAppliedCredit: true,
        lombard,
        error: null,
      }),
    ),
    on(
      lombardApiActions.applyForCreditFailure,
      (state, { error }): LombardState => ({
        ...state,
        error,
        applying: false,
        hasAppliedCredit: false,
      }),
    ),
    on(
      lombardActions.loadConfirmationData,
      (state): LombardState => ({
        ...state,
        loading: true,
      }),
    ),
    on(
      lombardApiActions.loadConfirmationDataSuccess,
      (state, { confirmationData }): LombardState => ({
        ...state,
        loading: false,
        confirmationData,
        error: null,
      }),
    ),
    on(
      lombardApiActions.loadConfirmationDataFailure,
      (state, { error }): LombardState => ({
        ...state,
        error,
        loading: false,
      }),
    ),
    on(
      lombardActions.clearConfirmationData,
      (state): LombardState => ({
        ...state,
        confirmationData: null,
      }),
    ),
    on(
      lombardActions.dismissTeaser,
      (state): LombardState => ({
        ...state,
        hasDismissedTeaserRecently: true,
      }),
    ),
    on(
      lombardActions.dismissOffer,
      (state): LombardState => ({
        ...state,
        loading: true,
      }),
    ),
    on(
      lombardApiActions.dismissOfferSuccess,
      (state, { lombard }): LombardState => ({
        ...state,
        lombard,
        loading: false,
        hasDismissedOffer: true,
        error: null,
      }),
    ),
    on(
      lombardApiActions.dismissOfferFailure,
      (state, { error }): LombardState => ({
        ...state,
        error,
        loading: false,
        hasDismissedOffer: false,
      }),
    ),
  ),
});
